import { useCallback, useEffect, useRef, useState } from "react";
import { fetchEventBoard } from "./api";

export function useEventBoardState({ eventId, dancerId, occurrenceDate }) {
  const [board, setBoard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const load = useCallback(async ({ silent = false } = {}) => {
    if (!eventId || !dancerId) return;
    if (!silent) setLoading(true);
    try {
      const data = await fetchEventBoard(eventId, { dancerId, occurrenceDate });
      if (!mountedRef.current) return;
      setBoard(data);
      setError(null);
    } catch (e) {
      if (!mountedRef.current) return;
      setError(e);
    } finally {
      if (mountedRef.current && !silent) setLoading(false);
    }
  }, [eventId, dancerId, occurrenceDate]);

  useEffect(() => {
    if (!eventId || !dancerId) return;
    load();
  }, [load, eventId, dancerId]);

  return { board, loading, error, reload: load };
}
